import { Avatar } from "shared/components/Avatar";
import { Card } from "shared/components/Card";
import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowDown01Icon,
  UserCircle02Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

import type { SelectedUserData } from "./types";

interface AssigneeFilterTriggerProps {
  open: boolean;
  selectedCount: number;
  displayText: string;
  visibleSelectedUsers: SelectedUserData[];
  extraSelectedCount: number;
}

export const AssigneeFilterTrigger = ({
  open,
  selectedCount,
  displayText,
  visibleSelectedUsers,
  extraSelectedCount
}: AssigneeFilterTriggerProps) => (
  <Card className="w-fit max-w-[314px] px-4 py-2 grid grid-cols-[auto_1fr_auto] items-center gap-2 min-h-[40px] h-full shadow-xs">
    <HugeiconsIcon
      icon={UserCircle02Icon}
      className="text-content-200"
      size={20}
    />
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-content-200 font-bold text-xs shrink-0">
        Assigned to:{" "}
      </span>
      {selectedCount > 0 ? (
        <div className="flex items-center gap-2 min-w-0">
          <div className="flex items-center -space-x-2 shrink-0">
            {visibleSelectedUsers.map((user) => (
              <Avatar
                key={user.id}
                name={user.name}
                className="text-[9px] text-content-1000 border-2 border-content-1000-inverted"
                size={20}
              />
            ))}
            {extraSelectedCount > 0 ? (
              <div className="size-5 rounded-full bg-white text-content-1000 text-[9px] font-bold flex items-center justify-center border-2 border-content-1000-inverted">
                +{extraSelectedCount}
              </div>
            ) : null}
          </div>
          <span className="font-bold text-content-1000 text-xs truncate">
            {displayText}
          </span>
        </div>
      ) : (
        <span className="font-bold text-content-1000 text-xs truncate">
          {displayText}
        </span>
      )}
    </div>
    <HugeiconsIcon
      icon={ArrowDown01Icon}
      size={16}
      className={cx("text-content-1000 shrink-0", open ? "rotate-180" : "")}
    />
  </Card>
);
